import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurStory() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="10177" id="hero-introduction" ref={ref} className="relative w-full min-h-[85vh] flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className={`absolute inset-0 z-0 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 scale-100 blur-0" : "opacity-0 scale-105 blur-sm"}`}>
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605152/img/denver_skyline_dawn.png)]" />
        {}
        <div className="absolute inset-0 bg-primary/40 mix-blend-multiply" />
      </div>

      {}
      <div className={`relative z-10 container mx-auto px-6 text-center transition-all duration-700 ease-out delay-300 ${isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-8 scale-95"}`}>
        <div className="max-w-3xl mx-auto flex flex-col items-center gap-8">
          {}
          <h1 className="font-serif font-semibold text-5xl md:text-7xl lg:text-8xl tracking-tight text-white drop-shadow-md">
            Personalized Prostate Cancer Guidance
          </h1>

          {}
          <p className="font-sans text-lg md:text-xl text-white/90 max-w-xl leading-relaxed">Over 1,000 patients supported. Navigating a diagnosis is complex. I provide the clarity and compassionate advocacy you need for your journey.</p>

          {}
          <div className="pt-4">
            <Button asChild className="rounded-full bg-primary text-primary-foreground px-10 py-6 text-base font-medium tracking-wide transition-all duration-300 hover:-translate-y-[2px] hover:shadow-xl hover:bg-primary/90 relative overflow-hidden group shadow-md">
              <Link to="/NavigationServicesPage">
                <span className="relative z-10">Navigation Services</span>
                {}
                <span className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-0" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}